class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this, button))
    );
  }

  onButtonClick(button, event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (button.name === 'plus') {
      if (previousValue === this.input.max) return;
      this.input.stepUp()
    } else this.input.stepDown();

    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}
if (!customElements.get('quantity-input')) {
  customElements.define('quantity-input', QuantityInput);
}
